<template>
  <div class="header">
    <div class="header-up">
      <div class="header-up-left">
        <div class="header-logo">
          <a></a>
        </div>
      </div>
      <div class="header-up-right">
        <div class="header-link">
          <ul class="header-ul">
            <li class="nav-main">
              <a :class="IsPC() ? '' :'aPhone'" href="http://www.nanyueguyidao.cn/Default.aspx" target="_blank">首页</a>
            </li>
            <li>
              <a :class="IsPC() ? '' :'aPhone'" href="http://www.nanyueguyidao.cn/Columns/MessageColumn.aspx?ColumnId=7"
                target="_blank">户外运动</a>
            </li>
            <li>
              <a :class="IsPC() ? '' :'aPhone'" href="http://www.nanyueguyidao.cn/Columns/MessageColumn.aspx?ColumnId=10"
                target="_blank">驿道活化</a>
            </li>
            <li>
              <a :class="IsPC() ? '' :'aPhone'" href="http://www.nanyueguyidao.cn/Columns/MessageColumn.aspx?ColumnId=1"
                target="_blank">文化之旅</a>
            </li>
            <li>
              <a :class="IsPC() ? '' :'aPhone'" href="http://www.nanyueguyidao.cn/Columns/MessageColumn.aspx?ColumnId=17"
                target="_blank">驿道讲堂</a>
            </li>
            <li>
              <a :class="IsPC() ? '' :'aPhone' " style="color: #b83113;" target="_blank">驿道旅游</a>
            </li>
            <li>
              <a :class="IsPC() ? '' :'aPhone'" href="http://www.nanyueguyidao.cn/map.aspx" target="_blank">电子地图</a>
            </li>
            <li>
              <a :class="IsPC() ? 'En' :'EnPhone'" href="http://www.nanyueguyidao.cn/Columns/GlobalSharing.aspx?ColumnId=34"
                target="_blank">Global Sharing</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="header-bom">
      <div class="header-bom-left">
        <div :class="isFocus?'header-search on':'header-search'">
          <input class="search-input" type="text" maxlength="200" minlength='1' placeholder="搜索..." @focus="focus"
            @blur="blur" v-model="keyWord" />
          <span class="magnify" @click="goSearchResult()"><i class="fa fa-search"></i></span>
        </div>
      </div>
      <div class="header-bom-right">
        <div class="LorR" v-show="isLogin == false">
          <router-link tag="a" to="/login" :class="!isc ? 'LRspan Lspan':'LRspan'"><i class="fa fa-user-o"></i>登录</router-link>
          <router-link tag="a" to="/register" :class="isc ? 'LRspan Lspan':'LRspan'" style="padding-right:0;">注册</router-link>
        </div>
        <div class="LorR" v-show="isLogin == true">
          <router-link tag="a" to="my" class="LRspan Lspan"><i class="fa fa-user-o"></i>{{nickname}}</router-link>
          <a class="LRspan" style="padding-right:0;" @click="goOut()">退出</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isFocus: false,
        isLogin: false,
        userinfoId: '',
        nickname: '',
        keyWord: ''
      }
    },
    props: ["isc"],
    methods: {
      // 判断PC端还是手机端
      IsPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      focus() {
        this.isFocus = true
      },
      blur() {
        this.isFocus = false
      },
      goOut() {
        this.$confirm('是否退出', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.$message({
            type: 'success',
            message: '成功退出!'
          });
          localStorage.clear();
          // sessionStorage.removeItem('token')
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('userInfo')
          sessionStorage.removeItem('userInfoId')
          this.$router.push("/login")
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出'
          });
        });
      },
      getUserInfo() {
        if(sessionStorage.getItem('userInfo')){
            this.nickname = JSON.parse(sessionStorage.getItem('userInfo')).nickname
            return
        }
        this.axios.post('/api/u_member/getDetail.do', this.qs({
          id: this.userinfoId
        })).then(res => {
          if (res.status == 200) {
            this.nickname = res.data.data.nickname
            if (localStorage.getItem('userInfoId')) {
              localStorage.setItem('token', res.data.token)
            }
            sessionStorage.setItem('token', res.data.token)
            sessionStorage.setItem('userInfo', JSON.stringify(res.data.data))
          }
        })
      },
      goSearchResult() {
        console.log(this.$route.path)
        if (this.$route.path == '/searchResult') {
          this.$emit('getWord', this.keyWord)
        } else {
          this.$router.push({
            name: 'searchResult',
            query: {
              keyWord: this.keyWord,
            }
          })
        }
      },
      loginOut(){
        this.isLogin = false
      },
      updateUserInfo(){
        this.isLogin = true
        this.nickname = JSON.parse(sessionStorage.getItem("userInfo")).nickname
      }
    },
    mounted() {
      if (localStorage.getItem("token") || sessionStorage.getItem("token")) {
        this.isLogin = true
      }
      if (localStorage.getItem('userInfoId')) {
        this.userinfoId = localStorage.getItem('userInfoId')
        this.getUserInfo()
      }

      if (sessionStorage.getItem('userInfoId')) {
        this.userinfoId = sessionStorage.getItem('userInfoId')
        this.getUserInfo()
      }
    }
  }
</script>

<style>
</style>
